export function parsePrompt(prompt: string): { text: string; context: Array<[string, string]> } {
  try {
    const parsed: unknown = JSON.parse(prompt);
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      const { message, ...rest } = parsed as Record<string, unknown>;
      const context = Object.entries(rest)
        .filter(([, v]) => typeof v === 'string' || typeof v === 'number')
        .map(([k, v]): [string, string] => [k, String(v)]);
      return { text: typeof message === 'string' ? message : '', context };
    }
  } catch {
    return { text: prompt, context: [] };
  }
  return { text: prompt, context: [] };
}
